function CtxTabContentAnimation ($animateCss, $timeout) {
    return {
        enter : function(element, done) {
            let animator,
                rect = element[0].getBoundingClientRect(),
                parents = element.parentsUntil('ctx-tabs'),
                parentElement = parents.find('.panes'),
                height = rect.height;

            if(parentElement.height() === height) {
                parentElement.css({height: 'auto'});
                parentElement.css({overflow: 'visible'});
            }
            else {
                parentElement.css({overflow: 'hidden'});
                animator = $animateCss(parentElement, { to: {height: height + 'px'}, duration: 0.25});
                if (animator) {
                    return animator.start().finally(function () {
                        parentElement.css({overflow: 'visible'});
                        $timeout(() => {
                            parentElement.css({height: 'auto'});
                        }, 500);
                        done();
                    });
                }
            }
            done();
        },
        leave : function(element, done) {
            done();
        }
    };
}

module.exports = CtxTabContentAnimation;




// WEBPACK FOOTER //
// ./src/shared/ctxTabs/ctxTabContent.animation.js